"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiService = void 0;
/* eslint-disable import/no-cycle */
const http_1 = require("@angular/common/http");
const core_1 = require("@angular/core");
const permissions_service_1 = require("../../../../components/authorization/permissions.service");
let ApiService = class ApiService {
    constructor(http, permissionsService) {
        this.http = http;
        this.permissionsService = permissionsService;
        this.headers = new http_1.HttpHeaders();
    }
    setAuthorization(token) {
        this.headers = new http_1.HttpHeaders({
            Authorization: `Bearer ${token}`,
        });
    }
    isAllowed(roles) {
        return this.permissionsService.isPermitted(roles);
    }
    get(path, params = new http_1.HttpParams()) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.http.get(`${API_URL}${path}`, { params, headers: this.headers }).toPromise();
        });
    }
    delete(path, params = new http_1.HttpParams()) {
        return this.http.delete(`${API_URL}${path}`, { params, headers: this.headers }).toPromise();
    }
    post(path, data, returnBlob) {
        if (!returnBlob)
            return this.http.post(`${API_URL}${path}`, data, { headers: this.headers }).toPromise();
        return this.http.post(`${API_URL}${path}`, data, { headers: this.headers, observe: 'response', responseType: 'blob' }).toPromise().then((res) => res.body);
    }
    postWithFiles(path, data, files) {
        const formData = new FormData();
        files.forEach((f, i) => {
            formData.append(`file${i}`, f, f.name);
        });
        Object.keys(data).forEach((key) => {
            formData.append(key, data[key]);
        });
        return this.http.post(`${API_URL}${path}`, formData, { headers: this.headers, observe: 'response', responseType: 'blob' }).toPromise().then((res) => res.body);
    }
    postFile(path, data) {
        const newHeaders = {};
        if (this.headers) {
            this.headers.keys().forEach((k) => {
                newHeaders[k] = this.headers.get(k) || '';
            });
        }
        const h = new http_1.HttpHeaders(newHeaders);
        h.set('Content-Type', 'application/x-www-form-urlencoded');
        return this.http.post(`${API_URL}${path}`, data, { headers: h })
            .toPromise();
    }
    put(path, data) {
        return this.http.put(`${API_URL}${path}`, data, { headers: this.headers }).toPromise();
    }
};
ApiService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [typeof (_a = typeof http_1.HttpClient !== "undefined" && http_1.HttpClient) === "function" ? _a : Object, typeof (_b = typeof permissions_service_1.PermissionsService !== "undefined" && permissions_service_1.PermissionsService) === "function" ? _b : Object])
], ApiService);
exports.ApiService = ApiService;
